import { observer } from "mobx-react-lite";
import styles from "./PermissionsUser.module.css";
import { permissionsStore } from "@/stores/PermissionsStore";
import { SampleAnyPermissions } from "@/components/permissions/sampleAnyPermissions/SampleAnyPermissions";
import { User } from "@/types/User.interface";

export const PermissionsUser = observer(({ user }: { user: User }) => {
  const permissions = permissionsStore.getPermissionsByRoleId(user.role!);
  const {
    users: usersAction,
    wines: winesAction,
    addresses: addressesAction,
    fairs: fairsAction,
    tours: toursAction,
    video_pages: video_pagesAction,
  } = permissions!.typePermissions;
  const { overPrivilegeNames: overPrivilege } = permissions!;

  return (
    <div className={styles.section}>
      <span>Права учетной записи</span>
      <SampleAnyPermissions typePermsName="users" typePermsData={usersAction} overPriv={overPrivilege} />
      <SampleAnyPermissions typePermsName="wines" typePermsData={winesAction} />
      <SampleAnyPermissions typePermsName="addresses" typePermsData={addressesAction} />
      <SampleAnyPermissions typePermsName="fairs" typePermsData={fairsAction} />
      <SampleAnyPermissions typePermsName="tours" typePermsData={toursAction} />
      <SampleAnyPermissions typePermsName="video_pages" typePermsData={video_pagesAction} />
    </div>
  );
});
